export default "__VITE_ASSET__COzstNPG__"